<template>
  <div>
    <CRow>
      <CCol md="12">
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                <strong>{{$t('documentDoc')}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">

                <CButton @click="print()" size="sm"
                         color="secondary"
                         class="mr-1">

                  {{ $t('buttons.print') }}
                </CButton>
              </CCol>
            </CRow>
          </CCardHeader>

          <CCard id="printMe">
            <CCardHeader>
              <CRow>
                <CCol col="3">
                  <CSelect
                      :options="[{label:this.$t('select'),value:1},
                      {label:this.$t('buy'),value:1},
                      {label:this.$t('sidebars.addReturnBuyDocument'),value:2},
                  {label:this.$t('sell'),value:3},
                  {label:this.$t('returnSell'),value:4},
                  {label:this.$t('FactorCurrency'),value:7},
                  {label:this.$t('components.receive'),value:10},
                  {label:this.$t('chequeListDocsReceive'),value:20},
                  {label:this.$t('payOperation'),value:30},
                  {label:this.$t('components.cheques'),value:40},
                  {label:this.$t('sidebars.payroll'),value:50},
                  ]"
                      :value.sync="selected_type"
                  />
                </CCol>


              </CRow>

            </CCardHeader>
            <CCardBody>

              <CDataTable
                  :items="doc_detail"
                  :fields="fields"
                  striped
                  border
                  :items-per-page="200"
                  hover
                  pagination
              >
                <template #row="{item,index}">

                  <td>
                    <strong >{{ index + 1 }}</strong>
                  </td>

                </template>


                <template #tafsiliTitle="{item,index}">

                  <td>
                    <strong >{{ item.tafsiliTitle }}</strong>
                  </td>
                </template>
                <template #accountName="{item}">
                  <td>
                    <strong >{{ item.accountName }}</strong>
                  </td>
                </template>
                <template #joz="{item,index}">

                  <td v-if="index!=doc_detail.length-1">
                    <br>
                    <strong v-if="item.debtor"  style="float: right" >{{ get_currency(item.deptorCreditor) }}</strong>
                    <strong v-else style="float: right" >{{ get_currency(item.deptorCreditor) }}</strong>
                  </td>
                  <td v-else>
                 </td>
                </template>

                <template #creditor="{item}">

                  <td>
                    <strong   style="float: right" >{{ get_currency(Math.abs(item.creditor)) }}</strong>

                  </td>

                </template>
                <template #debtor="{item}">

                  <td>
                    <strong style="float: right" >{{ get_currency(item.debtor) }}</strong>
                  </td>
                </template>


              </CDataTable>


            </CCardBody>
          </CCard>

      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes',
  ],
  styles: [
    'https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css',
    'https://omdesho.ir/print_css/printing.css',

  ]
}

Vue.use(VueHtmlToPaper, options);
var items_data = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      VUE_APP_Currency: localStorage.getItem('currency'),
      VUE_APP_NAME: localStorage.getItem('app_name'),
      date: '',
      selected_type: 1,
      pre_finalize:false,
      doc_id :'',
      product_items: items_data.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:3%;padding:0px'},
        {key: 'accountTitle', label: this.$t('accountSarfasl'), _style: 'width:20%;padding:0px'},
        // {key: 'unit', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'tafsiliTitle', label: this.$t('components.bankAccTitle'), _style: 'width:20%;padding:0px'},
        {key: 'accTypeTitle', label: this.$t('type'), _style: 'width:20%;padding:0px'},
        {key: 'joz', label: this.$t('subAmount'), _style: 'width:10%;padding:0px'},

        {key: 'debtor', label: this.$t('bedehkar'), _style: 'width:10%;padding:0px'},
        {key: 'creditor', label: this.$t('bestankar'), _style: 'width:10%;padding:0px'},
        // {key: 'takhfif', label: this.$t('tables.off'), _style: 'padding:0px'},
        // {key: 'tax', label: this.$t('tables.tax'), _style: 'padding:0px'},
        // {key: 'summary', label: this.$t('tables.summary'), _style: 'padding:0px'},
      ],


      pre_finalize_items: [{
        tafzili:"9",
        moein:"8",
        kol:"12",
        account:"پرداخت هزینه سوخت",
        price_joz:"120000",

        price_bedehkar:"1000",
        price_bestankar:"1000"},{
        tafzili:"",
        moein:"",
        kol:"",
        account:"",
        price_joz:this.$t('totalDoc'),
        price_bedehkar:"1000",
        price_bestankar:"1000"}],



      selectedTypeQty: 1,
      selectedTypeLabel: this.$t('components.seller'),
      selectedTypeLabelRevert: this.$t('buttons.buyer'),
      selectedTypeTitle: this.$t('components.documentBuy'),
      selectedType: 1,
      tablo: '',
      address: '',

      vMobile: '',
      partyMobile: '',
      tozikonandeMobile: '',

      document_person: '',
      document_person_id: '',
      document_summary: '',
      document_visitor: '',
      document_driver: '',
      doc_detail: [],


      product_name: '',
      product_count: '',
      product_unit: '',
      product_summary: '',
      product_price: '',

      unit_items: [],
      doc_status: 0,
      // total_price: 0,
      details: [],
      permission_group_items: [],
      selected_permission_group: 0,

      places_items: [],
      unit_items_filtered: [],
      selected_place: '',
      selected_product: null,

      status_form: 0,
      master_id: 0,
      document_result_price: [],

    }
  }, mounted() {
this.doc_id = this.$route.params.doc_id;
    this.$root.root_validate_errors = [];

    // this.get_product_units();
    this.get_document_master();


    bus.$on('delete_confirm_factor'+this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  created() {

  },
  watch: {
    'selected_type': function () {
      this.get_document_master();
    },

    'selectedType': function () {
      if (this.selectedType == 1) {

        this.selectedTypeLabel = this.$t('components.seller');
        this.selectedTypeLabelRevert = this.$t('components.buyer');
        this.selectedTypeQty = 1;
        this.selectedTypeTitle = this.$t('components.documentBuy');
      }
      if (this.selectedType == 3) {
        this.selectedTypeLabel = this.$t('components.buyer');
        this.selectedTypeLabelRevert = this.$t('components.seller');
        this.selectedTypeQty = -1;
        this.selectedTypeTitle = this.$t('components.documentSell');

      }
      if (this.selectedType == 5) {
        this.selectedTypeLabel = this.$t('components.employee');
        this.selectedTypeLabelRevert = this.$t('components.company');
        this.selectedTypeQty = 1;
        this.selectedTypeTitle = this.$t('components.documentFirst');

      }
    },
  },
  methods: {
    finalize() {
      var self = this;


      const formData = new FormData();

      var url = "AddAccountDocFinal";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          self.get_document_master();

        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_product_units() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetProductUnits', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.unit_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    print() {
      // Pass the element id here
      this.$htmlToPaper('printMe');
    },
    goEdit() {
      // Pass the element id here
      this.$router.push({path: "/dashboard/documents/edit-document/" + this.doc_id});
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    get_document_master() {
      var self = this;


      const formData = new FormData();

      var url = "GetDemoDocAutomatic";

      formData.append("docTypeId", this.selected_type);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
//     self.items_buy = content_data.data.map((item, row_id) => {
// // if(item.isCustomer){
//     return {...item, row_id}
          self.doc_detail = response.data.data
          var total_debtor = 0;
          var total_creditor = 0;
          self.doc_detail.forEach((val) => {
            if(val.deptorCreditor>0){
              total_debtor+=val.deptorCreditor;
              val.debtor = val.deptorCreditor
              val.creditor = 0
            }else{
              total_creditor+=val.deptorCreditor;
              val.creditor = val.deptorCreditor
              val.debtor = 0

            }

              });
          self.doc_detail.push({accTypeTitle:'',accountTitle:'',tafsiliTitle:self.$t('totalDoc'),debtor:total_debtor,creditor:total_creditor,});
console.log("detailssss",self.doc_detail)
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_document_result() {
      var self = this;


      const formData = new FormData();

      var url = "GetFactorResultByMasterId";

      formData.append("Id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.document_result_price = content_data.data;
          self.get_user_data();

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_document_details() {
      var self = this;


      const formData = new FormData();

      var url = "GetDocItemsByDocId";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.product_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}

          });


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog() {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], 'delete_confirm_factor'+this.confirm_delete_name);

      // this.status_form = this.masterFactorId;

    },
    get_user_data() {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetPersonById";

      formData.append('id', this.document_person_id);


      axios.post(url, formData, {}).then((res) => {
        var person  = res.data.data.person;
        self.document_person = person.personName +" "+ person.surName +" "+ person.mobileNo
        // self.document_person_remain_amount = res.data.data.mande;
        var tota_price = self.document_result_price[self.document_result_price.length-1].resultPrice;
        tota_price = tota_price.replaceAll(",","");

      tota_price =   parseInt(res.data.data.mande)+parseInt(tota_price)

        // self.document_result_price.push(obj)
        // obj = {resultTitle: "مبلغ نهایی", resultPrice:tota_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") };
        // self.document_result_price.push(obj)


      })
          .catch(function (error) {

            console.log(error);
          });


    },

    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteFactorMaster";


      formData.append('id', this.doc_id);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        // self.get_lists();
        //  this.$router.push({ path: '/dashboard/documents/daily-list/0'});
        this.$router.go(-1)

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    }

  }
}

</script>
